import { Navigate } from "react-router-dom";

function Ads() {
  return <Navigate to="/billboards" replace />;
}

export default Ads;
